import type { ReactElement } from 'react';
import type React from 'react';

type SVGProps = React.SVGAttributes<SVGElement>;

export const handleShowingBrandIconElement = (
  isNonPoker: boolean | unknown,
  BrandImage: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>,
  PokerImage: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>
): ReactElement => (isNonPoker ? BrandImage : PokerImage);

export const handleShowingBrandIconString = (
  isNonPoker: boolean | unknown,
  BrandImage: string,
  PokerImage: string
): string => (isNonPoker ? BrandImage : PokerImage);
